import { HIVE_SLASH_MENU_WIDGET } from './consts';
import { InnerSlashMenu, SlashMenu } from './slash-menu-popover';
import { HiveSlashMenuWidget } from './widget';

export function effects() {
  customElements.define(HIVE_SLASH_MENU_WIDGET, HiveSlashMenuWidget);
  customElements.define('hive-slash-menu', SlashMenu);
  customElements.define('inner-slash-menu', InnerSlashMenu);
}

declare global {
  interface HTMLElementTagNameMap {
    [HIVE_SLASH_MENU_WIDGET]: HiveSlashMenuWidget;
  }
}
